
const details = [
  {
    title: '이벤트 기간',
    content: '2025년 12월 1일 - 2026년 2월 28일',
    icon: 'ri-calendar-line'
  },
  {
    title: '참여 대상',
    content: '이벤트 기간 내 신규 촬영 고객, 기존 촬영 고객\n*촬영 상품을 20만원 이상 구매하거나 예약한 고객에 한해 이벤트 참여가 가능합니다',
    icon: 'ri-user-star-line'
  },
  {
    title: '당첨 안내',
    content: '2026년 3월 3일 당첨자께 개별 연락드립니다',
    icon: 'ri-trophy-line'
  },
  {
    title: '경품 전달',
    content: '영업일 기준 7일 이내에 개별 연락드립니다',
    icon: 'ri-gift-line'
  }
];

export default function EventDetails() {
  return (
    <section className="py-32 px-6 bg-neutral-900">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block w-16 h-px bg-neutral-600 mb-8"></div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-8 font-light tracking-tight text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
            Event Details
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {details.map((detail, index) => (
            <div 
              key={index}
              className="bg-neutral-800/50 p-10 border border-neutral-700 transition-all duration-300 hover:border-neutral-500 hover:bg-neutral-800"
            >
              <div className="flex items-start gap-6">
                <div className="flex items-center justify-center w-14 h-14 bg-neutral-700 flex-shrink-0">
                  <i className={`${detail.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-lg md:text-xl mb-3 font-light tracking-tight text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {detail.title}
                  </h3>
                  <p className="text-sm md:text-base text-neutral-400 leading-relaxed font-light whitespace-pre-line">
                    {detail.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 p-10 border border-neutral-700 bg-neutral-800/30">
          <p className="text-xs md:text-sm text-neutral-500 leading-relaxed font-light text-center">
            * 이벤트는 관련 약관에 따라 진행됩니다. 당첨자는 응모자 중 무작위로 선정됩니다. 경품은 재고 상황에 따라 변동될 수 있으며, 동등하거나 그 이상의 가치가 있는 상품으로 대체될 수 있습니다. 필요 시 이벤트 기간을 연장할 수 있습니다.
          </p>
        </div>
      </div>
    </section>
  );
}